export interface GanttZoomLevel {
  view: 'day' | 'week' | 'month';
  dayWidth: number;
  dayPadding: number;
  columnWidth: number;

  showDayOfWeek?: boolean;
  smallDateFontSize?: boolean;
  /** If true, clicking the zoom level buttons will use this specific level for day/week/month */
  defaultForView?: boolean;
}

// We might want to interpolate additional zoom levels in the future
export const ZOOM_LEVELS = (
  [
    {
      view: 'day',
      dayWidth: 128 + 64,
      dayPadding: 16,

      showDayOfWeek: true,
    },
    {
      view: 'day',
      dayWidth: 128,
      dayPadding: 16,

      showDayOfWeek: true,
    },
    {
      view: 'day',
      dayWidth: 64 + 32,
      dayPadding: 16,

      showDayOfWeek: true,
    },
    {
      view: 'day',
      dayWidth: 64 + 16,
      dayPadding: 16,

      showDayOfWeek: true,
    },
    {
      view: 'day',
      dayWidth: 64,
      dayPadding: 16,

      showDayOfWeek: true,
    },
    {
      view: 'day',
      dayWidth: 56,
      dayPadding: 16,

      showDayOfWeek: true,
    },
    {
      view: 'day',
      dayWidth: 40,
      dayPadding: 16,

      defaultForView: true,
      showDayOfWeek: true,
    },
    {
      view: 'day',
      dayWidth: 32,
      dayPadding: 16,
    },
    {
      view: 'day',
      dayWidth: 24,
      dayPadding: 16,

      smallDateFontSize: true,
    },
    {
      view: 'day',
      dayWidth: 16,
      dayPadding: 16,

      smallDateFontSize: true,
    },

    // Week view
    {
      view: 'week',
      dayWidth: 16,
      dayPadding: 16,
      defaultForView: true,
    },
    {
      view: 'week',
      dayWidth: 4,
      dayPadding: 16,
    },

    // Month view
    {
      view: 'month',
      dayWidth: 4,
      dayPadding: 4,
      defaultForView: true,
    },
    {
      view: 'month',
      dayWidth: 4,
      dayPadding: 2,
    },
    {
      view: 'month',
      dayWidth: 2,
      dayPadding: 2,
    },
  ] as const
).map(
  (zoomLevel: Omit<GanttZoomLevel, 'columnWidth'>): GanttZoomLevel => ({
    ...zoomLevel,
    columnWidth: zoomLevel.dayWidth + zoomLevel.dayPadding,
  })
);

export const DEFAULT_ZOOM_LEVEL = ZOOM_LEVELS.findIndex(
  zoomLevel => zoomLevel.view === 'day' && zoomLevel.defaultForView
);
